import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import KOutlineBg from '../KOutlineBg';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};

const HeroSection = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden pt-16" data-testid="hero-section">
      <img
        src="https://images.pexels.com/photos/6285158/pexels-photo-6285158.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop"
        alt="" aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-carbon/85" />
      <KOutlineBg />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 w-full">
        <div className="max-w-3xl">
          <motion.h1
            className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6 tracking-tight"
            {...fadeInUp}
          >
            MAKING <span className="yellow-highlight text-carbon">WORKPLACE</span><br />
            <span className="yellow-highlight text-carbon">CULTURE</span> COUNT
          </motion.h1>

          <motion.p
            className="text-base md:text-lg text-white/85 mb-8 max-w-2xl leading-relaxed"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            When absence, staff turnover, low trust or poor communication start affecting performance,
            the cause is not always obvious. Kalobrate helps you understand what is happening,
            what it is costing, and what needs to change.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 mb-10"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <Link
              to="/contact"
              className="bg-golden text-carbon px-7 py-3.5 font-semibold text-sm hover:bg-golden/90 transition-colors inline-flex items-center justify-center"
              data-testid="hero-talk-btn"
            >
              Talk to Ollie
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
            <Link
              to="/how-we-work"
              className="border border-white/30 text-white px-7 py-3.5 font-semibold text-sm hover:bg-white/10 transition-colors inline-flex items-center justify-center"
              data-testid="hero-how-link"
            >
              See how Kalobrate works
            </Link>
          </motion.div>

          <motion.p
            className="text-sm text-friar"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.45 }}
          >
            For mid-sized organisations in manufacturing, engineering, construction, energy,
            transport, tech and other operational sectors.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
